import type { FC, PropsWithChildren } from 'react';
import { MdxProvider, SiteProvider } from '@anywayseo/tools';

import FooterExtra from './footer-extra';
import useSite from './use-site';

type RootWrapperProps = PropsWithChildren;

const RootWrapper: FC<RootWrapperProps> = ({ children }) => {
  const { logo, metadata, navigation, localization } = useSite();

  return (
    <SiteProvider
      logo={logo}
      metadata={metadata}
      navigation={navigation}
      localization={localization}
      config={{
        footer: {
          extra: <FooterExtra />,
        },
      }}
    >
      <MdxProvider>{children}</MdxProvider>
    </SiteProvider>
  );
};

export default RootWrapper;
